import { useState } from "react";
import { initMercadoPago, Payment } from "@mercadopago/sdk-react";
import { auth } from "../firebase";

initMercadoPago(process.env.REACT_APP_MP_PUBLIC_KEY, { locale: "pt-BR" });

const PROCESSAR_URL = "https://us-central1-matriz3dsite.cloudfunctions.net/processarPagamento";

function PixScreen({ pixData, plano, onClose }) {
  const [copiado, setCopiado] = useState(false);

  const copiar = () => {
    navigator.clipboard.writeText(pixData.pixQrCode).catch(() => {});
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2500);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontWeight: 900, fontSize: 15, letterSpacing: 2, color: "#0a1628" }}>
          PRINT <span style={{ color: "#00d4aa" }}>CONTROL</span>
        </div>
        <div style={{ color: "#64748b", fontSize: 12, marginTop: 4 }}>
          Plano {{ monthly:"Mensal", annual:"Anual" }[plano] || plano}
        </div>
      </div>

      <div style={{ background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 12, padding: "12px 16px", marginBottom: 16 }}>
        <div style={{ fontSize: 14, color: "#15803d", fontWeight: 800, marginBottom: 4 }}>Pague via Pix</div>
        <div style={{ fontSize: 12, color: "#4ade80" }}>Escaneie o QR Code ou copie o código</div>
      </div>

      {pixData.pixQrCodeBase64 && (
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
          <img
            src={`data:image/png;base64,${pixData.pixQrCodeBase64}`}
            alt="QR Code Pix"
            style={{ width: 200, height: 200, borderRadius: 8, border: "1px solid #e2e8f0" }}
          />
        </div>
      )}

      {pixData.pixQrCode && (
        <div style={{ marginBottom: 16 }}>
          <div style={{
            background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8,
            padding: "8px 12px", fontSize: 10, color: "#64748b",
            wordBreak: "break-all", textAlign: "left",
            maxHeight: 56, overflowY: "auto", marginBottom: 8,
          }}>
            {pixData.pixQrCode}
          </div>
          <button onClick={copiar} style={{
            width: "100%", padding: "10px",
            background: copiado ? "#dcfce7" : "#f0fdf4",
            border: `1px solid ${copiado ? "#86efac" : "#bbf7d0"}`,
            color: copiado ? "#15803d" : "#16a34a",
            borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer",
          }}>
            {copiado ? "✓ Copiado!" : "📋 Copiar código Pix"}
          </button>
        </div>
      )}

      <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 16 }}>
        Após o pagamento, clique em verificar para liberar o acesso.
      </div>

      <button onClick={() => window.location.reload()} style={{
        width: "100%", padding: "12px",
        background: "linear-gradient(135deg,#00d4aa,#0ea5e9)",
        border: "none", color: "#04111f",
        borderRadius: 10, fontSize: 13, fontWeight: 800, cursor: "pointer", marginBottom: 8,
      }}>
        ✓ Já paguei — Verificar acesso
      </button>

      <button onClick={onClose} style={{
        background: "none", border: "none", color: "#94a3b8",
        fontSize: 12, cursor: "pointer", textDecoration: "underline",
      }}>
        Voltar
      </button>
    </div>
  );
}

export default function CheckoutBrick({ preferenceId, checkoutId, plano, uid, onSuccess, onClose, amount, couponCode }) {
  const [pixData, setPixData] = useState(null);

  // O valor é o que o servidor calculou a partir do preço do painel admin
  // (já com cupom aplicado). Não existe valor embutido aqui: um padrão fixo
  // mostraria na tela de pagamento um preço diferente do que seria cobrado.
  const initialization = { amount, preferenceId };

  const customization = {
    paymentMethods: {
      creditCard:   "all",
      debitCard:    "all",
      ticket:       "all",
      bankTransfer: ["pix"],
      mercadoPago:  ["wallet_purchase"],
    },
    visual: { hideFormTitle: true },
  };

  const onSubmit = async ({ formData }) => {
    const token = await auth.currentUser?.getIdToken(true);
    const res = await fetch(PROCESSAR_URL, {
      method:  "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body:    JSON.stringify({ ...formData, uid, plano, checkoutId, couponCode: couponCode || null }),
    });
    if (!res.ok) {
      const d = await res.json().catch(() => ({}));
      throw new Error(d.error || "Erro ao processar pagamento");
    }
    const data = await res.json();
    if (data.status === "approved") {
      onSuccess(plano);
    } else if (data.pixQrCode) {
      setPixData(data);
    }
    return data;
  };

  const onError = async (err) => console.error("[Brick]", err);

  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "rgba(0,0,0,0.88)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 10000, padding: 16,
    }}>
      <div style={{
        background: "#fff", borderRadius: 16,
        padding: "28px 20px 20px",
        maxWidth: 480, width: "100%",
        maxHeight: "90vh", overflowY: "auto",
        position: "relative",
      }}>
        <button onClick={onClose} style={{
          position: "absolute", top: 12, right: 14,
          background: "none", border: "none",
          fontSize: 20, cursor: "pointer", color: "#94a3b8", lineHeight: 1,
        }}>✕</button>

        {pixData ? (
          <PixScreen pixData={pixData} plano={plano} onClose={onClose} />
        ) : !amount ? (
          <div style={{ textAlign: "center", padding: "24px 4px 8px" }}>
            <div style={{ fontWeight: 800, fontSize: 14, color: "#0a1628", marginBottom: 8 }}>Não foi possível confirmar o valor</div>
            <div style={{ color: "#64748b", fontSize: 12, lineHeight: 1.6 }}>
              O servidor não informou o preço desta assinatura. Feche e tente de novo — nenhuma cobrança foi iniciada.
            </div>
          </div>
        ) : (
          <>
            <div style={{ textAlign: "center", marginBottom: 18 }}>
              <div style={{ fontWeight: 900, fontSize: 15, letterSpacing: 2, color: "#0a1628" }}>
                PRINT <span style={{ color: "#00d4aa" }}>CONTROL</span>
              </div>
              <div style={{ color: "#64748b", fontSize: 12, marginTop: 4 }}>
                Plano {{ monthly:"Mensal", annual:"Anual" }[plano] || plano}{amount ? ` — R$ ${amount.toFixed(2)}` : ""}
              </div>
            </div>
            <Payment
              initialization={initialization}
              customization={customization}
              onSubmit={onSubmit}
              onError={onError}
              onReady={() => {}}
            />
          </>
        )}
      </div>
    </div>
  );
}
